module.exports = __webpack_public_path__ + "static/lighting_demo-fa931f97252f1b360eeefc72fd2c5ca5.gif";